import styled from "@emotion/styled"
import { Button } from "@mui/material"
import Link from "next/link"
import colors from "theme/colors"
import { Container, Desktop, Mobile, NewText } from "ui"
import { extractProperty, getNonUmbracoUrl } from "utils"
import { getNonUmbracoURL } from "utils/utils"

export const StyledContainer = styled.div`
  margin: 32px 0;
  ${(props) => props.theme.breakpoints.up("md")} {
    margin-top: 80px;
    margin-bottom: 40px;
  }
`

const StyledBackground = styled.div<{ noRadius?: boolean }>`
  background-image: url("/invblock.png");
  background-size: cover;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 32px 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    flex-direction: row;
    padding: 80px 32px;
  }
  gap: 32px;
  align-items: center;
  border-radius: ${(props) => (props.noRadius ? "0" : "16px")};
`

const Width = styled.div`
  width: 100%;
  flex: 1 0 0;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 70%;
  }
`
const StyledButton = styled(Button)`
  background: white;
`
const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("md")} {
    width: 80%;
  }
`
const StyledLink = styled(Link)`
  align-self: end; /* display: flex; */

  /* justify-content: end; */
`
type Props = {
  data: any
  locale: string
}

function InvestmentBlock({ data, locale }: Props) {
  const header = extractProperty(data, "blockTitle") as string | undefined
  const content = extractProperty(data, "blockContent") as string | undefined
  const button = extractProperty(data, "blockButton") as {
    name: string
    url: string
  }[]
  const buttonName = button?.[0]?.name
  const buttonUrl = button?.[0]?.url

  return (
    <StyledContainer>
      <Desktop>
        <Container>
          <StyledBackground>
            <Width>
              <TextBox>
                <NewText component={"h3"} desktopFontSize={32} color={colors.black}>
                  {header}
                </NewText>
                <NewText
                  component={"p"}
                  desktopFontSize={18}
                  desktopLineHeight={"25.92px"}
                  color={colors.black}
                  dangerouslySetInnerHTML={{
                    __html: (content || "").replace(/<\/?p>/g, ""),
                  }}
                />
              </TextBox>
            </Width>
            <StyledLink href={getNonUmbracoUrl(buttonUrl) || ""}>
              <Desktop>
                <StyledButton variant="outlined" size="large" style={{ fontSize: 20 }}>
                  {buttonName}
                </StyledButton>
              </Desktop>
              <Mobile>
                <StyledButton variant="outlined" size="medium" style={{ fontSize: 20 }}>
                  {buttonName}
                </StyledButton>
              </Mobile>
            </StyledLink>
          </StyledBackground>
        </Container>
      </Desktop>
      <Mobile>
        <StyledBackground noRadius={true}>
          <Width>
            <TextBox>
              <NewText component={"h3"} desktopFontSize={18} color={colors.black}>
                {header}
              </NewText>
              <NewText
                component={"p"}
                desktopFontSize={18}
                desktopLineHeight={"25.92px"}
                color={colors.black}
                dangerouslySetInnerHTML={{
                  __html: (content || "").replace(/<\/?p>/g, ""),
                }}
              />
            </TextBox>
          </Width>
          <StyledLink
            href={
              getNonUmbracoURL({
                toDelete: `/${locale === "he" ? "he-il" : "en-us"}/group/pages`,
                url: buttonUrl,
              }) || ""
            }
          >
            <Desktop>
              <StyledButton variant="outlined" size="large" style={{ fontSize: 20 }}>
                {buttonName}
              </StyledButton>
            </Desktop>
            <Mobile>
              <StyledButton variant="outlined" size="medium" style={{ fontSize: 20 }}>
                {buttonName}
              </StyledButton>
            </Mobile>
          </StyledLink>
        </StyledBackground>
      </Mobile>
    </StyledContainer>
  )
}

export default InvestmentBlock
